import intl from 'react-intl-universal';
import exportIcon from '../../../../assets/icons/export.svg';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useExport } from './hooks/useExport';
import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import React from 'react';
import { GridItemData } from './GridItem';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../state/store';
import { chartDataSelectors } from '../../../../state/normalized/insights/chartDataSlice';

export const ExportInsightPdfOverflowMenu = (props: {
  gridItemData: GridItemData;
}) => {
  const { gridItemData } = props;

  const { exportInsightsToPDF } = useExport();

  const chartData = useSelector((state: RootState) =>
    chartDataSelectors.selectChartDataById(state, gridItemData.insightId)
  );

  const item = {
    label: intl.get('DASHBOARD_DETAIL.ACTION.EXPORT_PDF'),
    iconSrc: exportIcon,
    onSelect: async () => {
      const chartElement = document.getElementById(gridItemData.insightId);
      if (chartElement) {
        await exportInsightsToPDF(chartElement, gridItemData.name);
      }
    },
    action: DASHBOARD_DETAIL_ACTIONS.EXPORT_PDF,
  };

  const hasData = chartData && chartData.data;

  return hasData ? (
    <OverflowMenuItem
      key={item.label}
      className='flex items-center space-x-2'
      onSelect={item.onSelect}
      data-cy={`insight-${gridItemData.cardTypeId}__actions-popover__${item.action}`}
    >
      <Icon
        src={item.iconSrc}
        className={tailwindOverride(
          'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker text-lg',
          {
            'text-xl': item.iconSrc,
          }
        )}
      />
      <Typography
        variant='label'
        className='group-hover:text-secondary-darker cursor-pointer'
      >
        {item.label}
      </Typography>
    </OverflowMenuItem>
  ) : (
    <></>
  );
};
